import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import AddMemberToCollection from '@components/assign-team-member/AddMemberToCollection';
import { BackButton } from '@components/buttons/BackButton';
import CollectionAddAndEdit from '@components/CollectionAddAndEdit';
import CommonImage from '@components/CommonImage';
import UploadStyles from '@components/design-uploads/UploadStyles';
import ListViewType from '@components/ListViewType';
import MoodBoard from '@components/moodboard/MoodBoard';
import RangePlanTable from '@components/rangePlan/RangePlanTable';
import { ENTITY_TYPE as RANGE_PLAN_ENTITY_TYPE } from '@components/rangePlan/constants';
import SampleComment from '@components/SampleComment';
import { toastError, toastSuccess, toastWarning } from '@components/Toast';

import CollectionPresentation from '@features/collection/components/CollectionPresentation';
import CollectionTags from '@features/collection/components/CollectionTags';
import { CostGettingItem } from '@features/collection/components/CostGettingItem';
import CostingList from '@features/collection/components/CostingList';
import PublishDesign from '@features/collection/components/PublishDesign';
import CollectionDetailsTableView from '@features/collection/details/CollectionDetailsTableView';
import CreateSetOrder from '@features/collection/details/CreateSetOrder';
import DeleteSetOrder from '@features/collection/details/DeleteSetOrder';
import DesignCard from '@features/collection/details/DesignCard';
import StyleDetailsBottomActions from '@features/collection/details/StyleDetailsBottomActions';
import StyleDraftBoard from '@features/collection/details/StyleDraftBoard';
import ShareSuggestedCollection from '@features/collection/ShareSuggestedCollection';
import UploadCollectionImage from '@features/collection/UploadCollectionImage';
import MultipleTechpackJourney from '@features/collection/techpack-journey/components/MultipleTechpackJourney';
import ConfirmationModal from '@features/crm/components/ConfirmationModal';
import UpdateFittingModal from '@features/designTool/components/UpdateFittingModal';
import SelectFolderPopup from '@features/favourites/components/SelectFolderPopup';
import Chip from '@features/filter/Chip';
import {
	allFilterPages,
	collectionDetailsFieldList,
	getFilterParams
} from '@features/filter/static/filterUtil';
import FilterComponent from '@features/filter/v2/FilterComponent';
import RequestedSampleFromCollection from '@features/sampleDevelopment/components/RequestedSampleFromCollection';
import SampleDevelopment from '@features/sampleDevelopment/components/SampleDevelopment';
import FileUploads from '@features/blockSuggestion/components/fileUpload/FileUploads';
import { MIX_PANEL_EVENTS } from '@features/project-management-tools/constents';

import { setCurrentActivePage } from '@store/actions/ActivePageAction';
import { storeProductData } from '@store/actions/DesignAction';
import { clearDesignViewModalInfo, setDesignViewModalInfo } from '@store/actions/DesignViewModalAction';
import { clearGlobalFilter, replaceDetailsPageFilterFields } from '@store/actions/FilterAction';
import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { likeProduct, storeCollectionProducts } from '@store/design/action';

import { unmarkProductBlock } from '@services/assetsService';
import {
	doCollectionWiseDraftByProductId,
	doCollectionWiseUnDraftByProductId,
	fetchAllProductTags,
	getCollectionDetailsCount,
	getCollectionDetailsFilterFields,
	getCollectionDetailsTagsCount,
	updateCollectionById
} from '@services/collectionService';
import { setSystemUserPreferences } from '@services/commonService';
import { getFittingResponse } from '@services/measurementService';
import { getPickAndChoosePrice } from '@services/productService';

import { default as apiClient, default as ApiClient } from '@lib/apiClient';

import {
	addDataToArrayIndex,
	capitalizeFirstLetter,
	checkUserType,
	getPrimaryUserType,
	getRequestFrom,
	getUserPreference,
	groupByKey,
	isPageReachBottom,
	isRequestFromCosting,
	isRequestFromPhotography,
	isRequestFromSample,
	isShowPriceOnDesign,
	printApiError,
	replaceUnderLine
} from '@utils/Util';

import { LIST_VIEW_TYPE } from '@/constants/constant';

import {
	useAddPersonalSettingMutation,
	useArtboardProductTagMutation,
	useGetPersonalSettingsQuery,
	useMixPanelTrakingEventMutation
} from '@/api/commonApis';

const STATUS = ['INITIAL', 'DEVELOPMENT', 'COMPLETE', 'SOLD', 'TECHPACK'];
const POST_TYPE_FILTER = 'COLLECTION_COMMENT';
const getActiveStatus = {
	Complete: 'COMPLETE,PUBLISHED',
	Sold: 'SOLD',
	Published: 'PUBLISHED'
};

const SORTING_TYPE = ['tag,asc', 'stage,asc', 'category', 'priceRange'];

const CollectionDetails = () => {
	// const collectionDesignsListFromStore = useSelector((store) => store.design.collectionDesignsList);
	const selectedProductIds = useSelector((store) => store.product.selectedProductIds);
	const productsWithoutFabric = useSelector((store) => store.product.productsWithoutBodyFabric);
	const newPost = useSelector((store) => store.chatReducer.newMessage);
	const filterFields = useSelector((store) => store.filterFieldStore);
	const [isOpenDeleteConfirmation, setIsOpenDeleteConfirmation] = useState(false);
	const [requestTypeForSetOrder, setRequestTypeForSetOrder] = useState(null);
	const [showAddNewDesignModal, setShowAddNewDesignModal] = useState(false);
	const loading = useSelector((store) => store.loaderStore);
	const [draftTotalElements, setDraftTotalElements] = useState(false);
	const [textSearchParameter, setTextSearchParameter] = useState('');
	const [isCompleteLoading, setIsCompleteLoading] = useState(false);
	const [isSearchBoxHidden, setIsSearchBoxHidden] = useState(true);
	const [isShowDraftBoard, setIsShowDraftBoard] = useState(false);
	const [isEditCollection, setIsEditCollection] = useState(false);
	const [isShowPriceType, setIsShowPriceType] = useState(false);
	const [currentStatusTab, setCurrentStatusTab] = useState('');
	const [isEditReadOnly, setIsEditReadOnly] = useState(false);
	const [isOpenSetOrder, setIsOpenSetOrder] = useState(false);
	const [productWiseTags, setProductWiseTags] = useState([]);
	const [selectedStyle, setSelectedStyle] = useState(null);
	const [totalElements, setTotalElements] = useState(null);
	const [draftProducts, setDraftProducts] = useState([]);
	const [costItemsList, setCostItemsList] = useState([]);
	const [showComment, setShowComment] = useState(false);
	const [allCheckBox, setAllCheckBox] = useState(false);
	const [activeTab, setActiveTab] = useState('designs');
	const [setOrderType, setSetOrderType] = useState('');
	const [isUpdating, setIsUpdating] = useState(false);
	const [productList, setProductList] = useState([]);
	const [stageCounts, setStageCounts] = useState({});
	const [requestFromParam, setRequestFromParam] = useState();
	const [collection, setCollection] = useState({});
	const [uploadType, setUploadType] = useState('');
	const [defaultViewType, setDefaultViewType] = useState();
	const [tagCounts, setTagCounts] = useState({});
	const [hasNext, setHasNext] = useState(true);
	const [isPlay, setIsPlay] = useState(false);
	const [sort, setSort] = useState('');
	const [page, setPage] = useState(0);
	// const [filterParams, setFilterParams] = useState('');
	const [showBlockInfoModal, setShowBlockInfoModal] = useState(false);
	const [isBottomCategory, setIsBottomCategory] = useState(false);
	const [markProductId, setMarkProductId] = useState(null);
	const [openConfirmation, setOpenConfirmation] = useState(false);
	const [unmarkPorductid, setUnmarkProductId] = useState(false);
	const [fittingResponse, setFittingResponse] = useState(null);
	const [blockSaveType, setBlockSaveType] = useState('');
	const [isOpenDraftTooltop, setOpenDraftTooltop] = useState(false);
	const [idsForOfferPrice, setIdsForOfferPrice] = useState([]);
	const [allOfferPrices, setAllOfferPrices] = useState([]);
	const [isShowFavouriteFolderPopup, setIsShowFavouriteFolderPopup] = useState(false);
	const [isShowCreateNew, setIsShowCreateNew] = useState(false);
	const [currentLikedStyle, setCurrentLikedStyle] = useState(null);
	const userPreference = getUserPreference();
	const [defaultFolder, setDefaultFolder] = useState(null);
	const [isSelectOnNextPage, setIsSelectOnNextPage] = useState(false);
	const [showFilter, setShowFilter] = useState(false);
	const [isShowPublishDesign, setIsShowPublishDesign] = useState(false);
	const [artboardProducts, setArtboardProducts] = useState(null);
	const [selectedJourneyTab, setSelectedJourneyTab] = useState('upload');
	const [mergedFilesCount, setMergedFilesCount] = useState(0);

	const [mixPanelTrakingEvent] = useMixPanelTrakingEventMutation();
	const [addPersonalSetting] = useAddPersonalSettingMutation();
	const [artboardProductTag, { data: artboardProductTags }] = useArtboardProductTagMutation();
	const [failedTaskUpdateIds, setFailedTaskUpdateIds] = useState([]);
	const { id } = useParams();

	const { data: personalSettings, isSuccess: isSettingsLoaded } = useGetPersonalSettingsQuery({
		settingKey: 'COLLECTION_DETAILS_FILTER',
		params: { entityId: id, entityType: 'COLLECTION' }
	});

	useEffect(() => {
		setArtboardProducts((prev) => ({
			...prev,
			...artboardProductTags
		}));
	}, [page, artboardProductTags]);

	useEffect(() => {
		if (!isSettingsLoaded) {
			return;
		}

		const handler = setTimeout(() => {
			dispatch(openLoader());
			getCollectionProducts(0);
			dispatch(closeLoader());
		}, 100);

		return () => clearTimeout(handler);
	}, [filterFields, sort, isSettingsLoaded]);

	useEffect(() => {
		if (activeTab === 'designs') {
			(async () => {
				await getCollectionProducts(0);
			})();
		}
	}, [activeTab]);

	const loadingRef = useRef(false);
	const prevDefaultRef = useRef(null);
	const collectionRef = useRef({});

	const [size] = useState(30);
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const location = useLocation();

	let previousCancel;

	useEffect(() => {
		if (
			personalSettings?.value &&
			parseInt(personalSettings?.entityId) === parseInt(id) &&
			personalSettings?.entityType === 'COLLECTION'
			// parseInt(userId?.id) === parseInt(personalSettings?.userId)
		) {
			dispatch(replaceDetailsPageFilterFields(JSON.parse(personalSettings?.value)));
		}
	}, [personalSettings?.value]);

	useEffect(() => {
		return () => {
			dispatch(clearGlobalFilter());
		};
	}, []);

	useEffect(() => {
		setIsShowPriceType(isShowPriceOnDesign());
		let path = location.pathname;
		if (location.search) {
			path += `${location.search}`;
		}
		localStorage.setItem('fromRoute', path);
		const params = new URLSearchParams(location.search);
		const selectedTab = params.get('tab');
		const openTab = params.get('openUploadPanel');
		const isShowComment = params.get('showComment');
		if (openTab) {
			let addDesign = document.getElementById('design-tool-upload-button');
			addDesign.click();
		}
		if (isShowComment) {
			setShowComment(true);
		}

		const isNotRequestFromCollection = () => new URLSearchParams(location.search).get('requestFrom');
		let userInfo = localStorage.getItem('userInfo');
		if (userInfo) {
			userInfo = JSON.parse(userInfo);
			setDefaultViewType(userInfo.systemPreference?.collectionDetailsViewPage);
			setSort(
				isNotRequestFromCollection()
					? isRequestFromPhotography()
						? 'product.id,DESC'
						: 'id,asc'
					: userInfo.systemPreference?.collectionDetailsPageSortType
						? userInfo.systemPreference?.collectionDetailsPageSortType
						: 'id,asc'
			);
		} else {
			userInfo = {};
		}

		if (selectedTab === 'moodboard') {
			setActiveTab('moodboard');
		} else if (selectedTab === 'development') {
			setActiveTab(selectedTab);
		}

		if (!parseInt(id)) {
			toastError('Invalid collection id.');
			return;
		}
		getCollectionDetails(id);
		const statusTab = params.get('status');
		setCurrentStatusTab(getActiveStatus[statusTab]);
	}, [id]);

	const collectionFilters = () => {
		delete collectionDetailsFieldList.collection;
		return collectionDetailsFieldList;
	};
	useEffect(() => {
		setDefaultFolder(userPreference?.DEFAULT_FAVOURITE_FOLDER?.id || -1);
	}, [userPreference?.DEFAULT_FAVOURITE_FOLDER?.id]);

	useEffect(() => {
		if (showFilter) {
			const { filterParams } = getFilterParams(filterFields?.DETAILS_PAGE_FILTERS, id, 'collectionId');
			const newParams = {
				...filterParams,
				availabilityStatusList: [currentStatusTab]
			};

			if (!currentStatusTab) {
				delete newParams.availabilityStatusList;
			}

			dispatch(getCollectionDetailsFilterFields(id, newParams));

			if (Object.keys(filterFields?.DETAILS_PAGE_FILTERS).length > 0) {
				addPersonalSetting({
					body: {
						key: 'COLLECTION_DETAILS_FILTER',
						value: JSON.stringify(filterFields),
						entityId: id,
						entityType: 'COLLECTION'
					}
				});
			}
		}
	}, [id, filterFields, showFilter]);

	const fetchAllTags = async (search) => {
		try {
			// dispatch(openLoader());
			let params = '?type=PRODUCT_COLLECTION_TAGS&entityActivityType=PRODUCT_TAG_UPDATE';
			if (search) {
				params += `&search=${encodeURIComponent(search)}`;
			}
			const source = axios.CancelToken.source();
			previousCancel && previousCancel();
			previousCancel = source.cancel;

			const data = await fetchAllProductTags(params, source.token);
			previousCancel = null;

			setProductWiseTags(data);
			dispatch(closeLoader());
		} catch (error) {
			if (!axios.isCancel(error)) {
				dispatch(closeLoader());
			}
		}
	};

	useEffect(() => {
		(async () => {
			await fetchAllTags();
		})();
	}, [id]);

	useEffect(() => {
		loadingRef.current = loading;
	}, [loading]);

	useEffect(() => {
		document.addEventListener('scroll', handleWindowScroll);
		return () => {
			document.removeEventListener('scroll', handleWindowScroll);
			dispatch(
				setCurrentActivePage({
					id: null,
					type: '',
					pageType: 'DETAILS'
				})
			);
			document.title = 'Nitex - the easiest clothing manufacturing software';
		};
	}, [sort, filterFields, defaultViewType, dispatch]);

	const handleWindowScroll = async () => {
		if (isPageReachBottom() && loadingRef.current === false) {
			let { totalElements, data } = collectionRef.current;
			if (totalElements > 0 && totalElements !== data.length && activeTab === 'designs') {
				let oldPage = collectionRef.current?.currentPage || 0;
				await getCollectionProducts(oldPage + 1, true);
			}
		}
	};

	useEffect(() => {
		(async () => {
			await fetchDraftProductList();
		})();
	}, [id]);

	useEffect(() => {
		if (
			prevDefaultRef.current &&
			defaultViewType === LIST_VIEW_TYPE.LIST_VIEW &&
			prevDefaultRef.current !== LIST_VIEW_TYPE.LIST_VIEW
		) {
			(async () => {
				await getCollectionProducts(0, false);
			})();
		}
		prevDefaultRef.current = defaultViewType;
	}, [defaultViewType]);

	const isRequestFromSuggestedBuyer = () => {
		let paramList = new URLSearchParams(location.search);
		const requestFrom = paramList.get('status');
		return requestFrom === 'SUGGESTED_FOR_BUYER';
	};

	const renderTopBar = () => {
		return (
			<div className="filters" onClick={() => setShowFilter((prev) => !prev)}>
				<div className="filter-toggle no-after pl-0">
					<CommonImage src={`/icons/filter24.svg`} alt="filter" />
					<span>Filter</span>
				</div>
				<span className="items-count semibold-14 gray_dark_02 mr-4">{totalElements} Items</span>
			</div>
		);
	};

	// const onAddStyleClick = (type) => {
	// 	setShowAddNewDesignModal(true);
	// 	setUploadType(type);
	// };

	// const renderMoreDesignButton = () => {
	// 	return (
	// 		<div className="add-new-design mr-3">
	// 			<button
	// 				className="button text size32 px-0"
	// 				type="button"
	// 				id="dropdownStyles"
	// 				data-toggle="dropdown"
	// 				aria-haspopup="true"
	// 				aria-expanded="false"
	// 			>
	// 				<img
	// 					src={`${process.env.PUBLIC_URL}/icons/add-round.svg`}
	// 					alt="design"
	// 					className="mr-1"
	// 				/>{' '}
	// 				Style
	// 			</button>
	// 			<div className="dropdown-menu" aria-labelledby="dropdownStyles">
	// 				<ul>
	// 					<li>
	// 						<span onClick={() => onAddStyleClick('MULTIPLE')}>Multiple style</span>
	// 					</li>
	// 					<li>
	// 						<span onClick={() => onAddStyleClick('SINGLE')}>Single style</span>
	// 					</li>
	// 					{/* <li>
	// 						<span
	// 							data-toggle="modal"
	// 							data-target="#add-multiple-design"
	// 							onClick={() => {
	// 								localStorage.setItem('fromRoute', location.pathname);
	// 							}}
	// 						>
	// 							<img
	// 								src={`${process.env.PUBLIC_URL}/icons/Add-design.svg`}
	// 								alt="design"
	// 								className="mr-1"
	// 							/>{' '}
	// 							Add design{' '}
	// 						</span>
	// 					</li> */}
	// 				</ul>
	// 			</div>
	// 		</div>
	// 	);
	// };

	const uploadTechpackJourneyButtonRender = () => {
		return (
			<div className="upload-techpack-button mr-2">
				<button className="button text size32 px-0" onClick={() => setActiveTab('FILES')}>
					<img src={`${process.env.PUBLIC_URL}/icons/add-round.svg`} alt="design" /> Techpack
				</button>
			</div>
		);
	};

	const renderUploadTpEmptyState = () => {
		return (
			<button className="button size32" onClick={() => setActiveTab('FILES')}>
				<CommonImage src="/icons/add_white.svg" alt="design" />
				Techpack
			</button>
		);
	};

	const onAddNewDesignModal = async () => {
		setShowAddNewDesignModal(false);
		await onClearSelectedProducts();
		await getCollectionProducts(0);
		await getCollectionDetails(id);
		await fetchStageCounts();
	};

	// const getAllProductsIds = async (id) => {
	// 	try {
	// 		dispatch(openLoader());
	// 		const requestFrom = getRequestFrom();
	// 		let params = `${id}/products/ids?isDrafted=false`;
	// 		if (textSearchParameter) {
	// 			params += `&search=${textSearchParameter}`;
	// 		}
	// 		if (currentStatusTab) {
	// 			params += `&statusList=${currentStatusTab}`;
	// 		}
	// 		let quickSearchParams = generateQuickSearchParams();
	// 		if (quickSearchParams.length > 0) {
	// 			params += quickSearchParams;
	// 		}
	// 		if (requestFrom === 'blockLibrary') {
	// 			params += `&isBlock=true`;
	// 		}
	// 		const { data } = await Http.GET('getCollectionDetails', params);
	// 		dispatch(closeLoader());
	// 		return data;
	// 	} catch (error) {
	// 		dispatch(closeLoader());
	// 		printApiError(error);
	// 	}
	// };

	const onSortDetails = async (e) => {
		const value = e.target.value;
		await setSystemUserPreferences({
			collectionDetailsPageSortType: value
		});
		setSort(value);
	};

	const onPhotographySort = async (e) => {
		const value = e.target.value;
		setSort(value);
	};

	const isDisableCompleteButton = () => {
		return !!(collection?.isCompleted || isCompleteLoading || productList.length === 0);
	};

	const onComplete = async () => {
		try {
			setIsCompleteLoading(true);
			const { data } = await ApiClient.PUT('getCollectionDetails', {}, `${id}/complete`);
			setIsCompleteLoading(false);
			if (data.success) {
				toastSuccess(data.message);
				await getCollectionDetails(id);
			}
		} catch (e) {
			setIsCompleteLoading(false);
			printApiError(e);
		}
	};

	const onEditCollection = () => {
		setIsEditCollection((prev) => !prev);
	};

	useEffect(() => {
		let tmpProductList = productList.map((product) => {
			product.isSelected = selectedProductIds.includes(product.id);
			product.isAddedToList = !!selectedProductIds.length;
			return product;
		});
		setProductList(tmpProductList);
	}, [selectedProductIds]);

	const getCollectionDetails = async (collectionId) => {
		try {
			dispatch(openLoader());
			const { data } = await ApiClient.GET('getCollectionDetails', collectionId);
			document.title = data.name || '';
			if (!data.moodBoardId && collectionId) {
				setCollection((prev) => ({ ...prev, ...data }));
				// await addMoodBoard(collectionId);
			} else {
				setCollection(data);
			}
			dispatch(closeLoader());
		} catch (error) {
			dispatch(closeLoader());
			printApiError(error);
		}
	};

	const fetchStageCounts = async () => {
		try {
			// dispatch(openLoader());
			const requestFrom = getRequestFrom();
			let params = '?isDrafted=false&';
			if (textSearchParameter) {
				params += `search=${textSearchParameter}`;
			}
			if (requestFrom === 'blockLibrary') {
				params += `&isBlock=true`;
			}

			const stageCountDate = await getCollectionDetailsCount(id, params);
			const tagCountData = await getCollectionDetailsTagsCount(id, params);
			setStageCounts(stageCountDate);
			setTagCounts(tagCountData);
			dispatch(closeLoader());
		} catch {
			dispatch(closeLoader());
		}
	};

	const getFieldIds = (field) => {
		return (
			field?.filter((item) => Boolean(item?.key) && item?.key !== 'NA')?.map((item) => item?.key) || []
		);
	};

	const createRangePlanFilterParams = () => {
		const { params: filterParams, body } = getFilterParams(
			filterFields?.DETAILS_PAGE_FILTERS,
			id,
			'collectionId'
		);

		let params = '';
		const collectionIds = filterFields?.DETAILS_PAGE_FILTERS?.collectionCategory || [];
		const productGroupList = filterFields?.DETAILS_PAGE_FILTERS?.productGroupIdList || [];
		const fabricTypeList = filterFields?.DETAILS_PAGE_FILTERS?.fabricTypeList || [];

		if (collectionIds.length > 0) {
			params += `&categoryIdList=${getFieldIds(collectionIds)}`;
			body.categoryIdList = getFieldIds(collectionIds);
		}
		if (productGroupList.length > 0) {
			params += `&marketIdList=${getFieldIds(productGroupList)}`;
			body.marketIdList = getFieldIds(productGroupList);
		}

		if (fabricTypeList.length > 0 && !filterParams.includes('fabricTypeList')) {
			params += `&fabricTypeList=${getFieldIds(fabricTypeList)}`;
			body.fabricTypeList = getFieldIds(fabricTypeList);
		}
		return { params, body };
	};

	useEffect(() => {
		(async () => {
			await fetchStageCounts();
		})();
	}, [textSearchParameter, filterFields]);

	const getCollectionProducts = async (
		page = 0,
		merge = false,
		searchParam,
		key = 'getCollectionProducts'
	) => {
		const { params: filterParams, body } = getFilterParams(
			filterFields?.DETAILS_PAGE_FILTERS,
			id,
			'collectionId'
		);
		const requestBody = {
			...body,
			collectionId: id,
			isDrafted: false
		};
		const requestFrom = getRequestFrom();
		setRequestFromParam(requestFrom);
		let params = `${id}?page=${page}&size=${size}`;
		// let filterParams = `${id}/filter-options?isDrafted=false`;
		if (sort && !STATUS.includes(sort)) {
			params += `&sort=${sort}`;
			// requestBody.sort = sort;
		}
		if (sort && STATUS.includes(sort)) {
			params += `&priority=${sort}`;
			requestBody.priority = sort;
		}
		if (searchParam) {
			params += `&search=${searchParam}`;
			requestBody.search = searchParam;
		}
		if (currentStatusTab) {
			params += `&statusList=${currentStatusTab}&filterSubCategoryList=${currentStatusTab}`;
			requestBody.availabilityStatusList = [currentStatusTab];
			// requestBody.filterSubCategoryList = [currentStatusTab];
		}

		if (defaultViewType === LIST_VIEW_TYPE.LIST_VIEW) {
			params += `&isListView=true`;
			requestBody.isListView = true;
		}
		if (requestFrom === 'blockLibrary') {
			params += `&isBlock=true`;
			requestBody.isBlock = true;
		}
		const { params: rangePlanFilterParams, body: rangePlanFilterBody } = createRangePlanFilterParams();
		if (rangePlanFilterParams.length > 0) {
			params += rangePlanFilterParams;
			requestBody.rangePlanFilterBody = rangePlanFilterBody;
		}

		// let key = 'getCollectionProducts';
		if (requestFrom === 'photography') {
			key = 'fetchCollectionForPhotography';
		} else if (requestFrom === 'costing') {
			key = 'fetchCollectionForCosting';
		}

		try {
			dispatch(openLoader());
			const { data } =
				key === 'getCollectionProducts'
					? await apiClient.POST(key, requestBody, `${id}?page=${page}&size=${size}&sort=${sort}`)
					: await apiClient.GET(key, params + filterParams);
			artboardProductTag(data?.data?.map((item) => item?.id));
			if (data.currentPage > 0) {
				//mergedData = getUniqueObjectsById([...collectionRef.current.data, ...data.data]); // previous logic
				data.data = [...collectionRef.current.data, ...data.data];
			}
			if (merge) {
				let tmpProductList = [...data.data];
				if (allCheckBox) {
					tmpProductList.map((product) => {
						product.isSelected = selectedProductIds.includes(product.id);
						product.isAddedToList = !!selectedProductIds.length;
						return product;
					});
				}
				if (sort === 'id,desc') {
					setProductList(tmpProductList);
				} else {
					setProductList(tmpProductList);
				}
			} else {
				setProductList([...data.data]);
			}

			collectionRef.current = JSON.parse(JSON.stringify(data));
			setPage(data.currentPage);
			setHasNext(data.data.length === size);
			setTotalElements(data.totalElements);
			dispatch(closeLoader());
		} catch (error) {
			dispatch(closeLoader());
			printApiError(error);
		}

		const scrollPosition = localStorage.getItem('scrollPosition');
		if (scrollPosition !== null) {
			window.scrollTo(0, scrollPosition);
			localStorage.removeItem('scrollPosition');
		}
	};

	const addToCollection = async (product) => {
		try {
			setIsUpdating(true);
			let body = {
				id,
				productIds: [product.id],
				async: false
			};
			const { data } = await ApiClient.POST('addProductToCollection', body);
			if (data.success) {
				setProductList((prev) => [...prev, data.payload[0]]);
				setIsUpdating(false);
				await getCollectionDetails(id);
				toastSuccess('Design copied to collection!');
			}
		} catch (error) {
			setIsUpdating(false);
			printApiError(error);
		}
	};

	const onUpdateCollection = async () => {
		setIsEditCollection((prev) => !prev);
		await getCollectionDetails(id);
	};

	// const onSelectAll = async (type) => {
	// 	if (type === 'SELECT') {
	// 		let list = await getAllProductsIds(id);
	// 		await dispatch(storeProductData('selectedProductIds', list));
	// 	} else {
	// 		await dispatch(storeProductData('selectedProductIds', []));
	// 	}
	// };

	const handleSelectAll = () => {
		const selectedProductIdsList = productList
			?.filter((product) => {
				if (product?.setPackStyleFlag === 'SET_STYLE') {
					return true;
				}
				return product?.isBasicInfoUpdated;
			})
			?.map((item) => item?.id);
		dispatch(storeProductData('selectedProductIds', selectedProductIdsList));
	};

	useEffect(() => {
		if (isSelectOnNextPage) {
			handleSelectAll();
		}
	}, [isSelectOnNextPage, productList?.length]);

	const addProductToPricing = async () => {
		try {
			dispatch(openLoader());
			let body = [];
			costItemsList.map((product) => {
				let total = 0;
				product.colorWiseSizeQuantityPairList.map((obj) => {
					obj.sizeQuantityPairList.map((pair) => {
						total += parseInt(pair.quantity) ? parseInt(pair.quantity) : 0;
						return total;
					});
					return total;
				});
				let temp = {
					collectionId: parseInt(id),
					colorWiseSize: JSON.stringify(product.colorWiseSizeQuantityPairList),
					productId: product.id,
					total
				};
				if (product.targetPrice) {
					temp.targetPrice = product.targetPrice;
				}
				body.push(temp);
			});
			const { data } = await ApiClient.POST('addForCostingBulk', body);
			if (data && data.success) {
				setCostItemsList([]);
				onEditCollection();
				toastSuccess(data.message);
			}
			dispatch(closeLoader());
		} catch (error) {
			dispatch(closeLoader());
			printApiError(error);
		}
	};

	const onRemoveProductFromCollection = async (collectionId, productId, isBlock) => {
		try {
			if (isBlock && !checkUserType('ADMIN')) {
				toastWarning('Only admin will be able to delete the measurement block techpack.');
			} else {
				dispatch(openLoader());
				let body = {
					id: collectionId,
					productIds: [productId]
				};
				const { data } = await ApiClient.POST('removeProductFromCollection', body);
				if (data && data.success) {
					toastSuccess(data.message);
					let updatedList = productList?.filter((item) => item.id !== productId);
					setProductList(updatedList);
					let updatedData = selectedProductIds.filter((id) => id !== productId);
					dispatch(storeProductData(updatedData));
					await getCollectionDetails(collectionId); // Corrected to use collectionId
				}
				dispatch(closeLoader());
			}
		} catch (error) {
			dispatch(closeLoader());
			printApiError(error);
		}
	};

	const onCreateOption = async (productId, idx) => {
		try {
			dispatch(openLoader());
			const { data } = await ApiClient.POST('createOption', {}, `${productId}/create-option`);
			toastSuccess('Option created');
			if (data) {
				let prevProductList = [...productList];
				let newList = addDataToArrayIndex(prevProductList, idx, data);
				let updatedList = newList?.map((item) => {
					if (item.id === productId) {
						if (!Object.prototype.hasOwnProperty.call(item, 'options')) {
							item['options'] = [
								{
									id: data?.id,
									referenceNumber: data?.referenceNumber
								}
							];
						} else {
							item['options'] = [
								...item['options'],
								{
									id: data?.id,
									referenceNumber: data?.referenceNumber
								}
							];
						}
					}
					return item;
				});
				setProductList(updatedList);
				setCollection((prev) => ({ ...prev, noOfProduct: prev.noOfProduct + 1 }));
			}
			dispatch(closeLoader());
		} catch (error) {
			dispatch(closeLoader());
			printApiError(error);
		}
	};

	const onClearSelectedProducts = async () => {
		await dispatch(storeProductData('selectedProductIds', []));
	};

	const handleTextSearch = async (e) => {
		setTextSearchParameter(e.target?.value);
		await getCollectionProducts(0, false, e.target?.value);
	};

	const handleUpdateDesignOnPublish = (productIds) => {
		const updatedProductList = productList.map((product) => {
			if (productIds.includes(product.id)) {
				return {
					...product,
					productStatusList: product.productStatusList.map((status) => ({
						...status,
						entity: 'DESIGN',
						status: 'Published'
					}))
				};
			}
			return product;
		});
		setProductList([...updatedProductList]);
	};

	const renderPanelBar = () => {
		return (
			<>
				<UploadCollectionImage
					addNewDesign={onAddNewDesignModal}
					collectionId={id}
					addToCollection={(product) => addToCollection(product)}
					productIdsOnCollection={productList?.map((item) => item.id)}
					isUpdating={isUpdating}
				/>
				{isEditCollection && (
					<CollectionAddAndEdit
						type="EDIT"
						title="Edit collection"
						onSubmiCollection={onUpdateCollection}
						onClose={() => setIsEditCollection(false)}
					/>
				)}
			</>
		);
	};

	const handleCommentClose = () => {
		setShowComment(false);
	};

	const onUpdateBasicInfo = (product) => {
		let updatedProductList = productList?.map((item) => {
			if (item.id === product.id) {
				item = product;
			}
			return item;
		});
		setProductList(updatedProductList);
	};

	const onCloseViewModal = async (isReloadNeeded) => {
		if (isReloadNeeded) {
			await getCollectionProducts(0);
		}
		dispatch(clearDesignViewModalInfo({}));
	};

	const onUpdateCostingStatus = (id) => {
		let tmpProductList = productList?.map((item) => {
			if (item.id === id) {
				item.costingCompleted = true;
			}
			return item;
		});
		setProductList(tmpProductList);
	};

	const updateProductStatus = () => {
		getCollectionDetails(id);
		getCollectionProducts(0);
	};

	const onBasicInfoUpdateSuccess = (id, updatedProduct) => {
		let orderedProductList = [];
		orderedProductList = productList?.map((product) => {
			if (product.id === id) {
				if (updatedProduct) {
					product = { ...product, ...updatedProduct };
				}
				product.isBasicInfoUpdated = true;
				return {
					...product
				};
			} else return product;
		});
		setProductList(orderedProductList);
	};

	const onUpdateDesignImage = (id, docUrl) => {
		let productList = productList?.map((item) => {
			if (item.id === id) {
				item.designDocuments[0].docUrl = docUrl;
			}
			return item;
		});
		setProductList(productList);
	};

	const setDesignIdToView = (product, openBasicInfo, defaultIsDesignEdit) => {
		dispatch(
			setDesignViewModalInfo({
				isShowMergeTechPack: product.isSet,
				id: product.id,
				onCloseViewModal: (id) => onCloseViewModal(id),
				onUpdateCostingStatus: (id) => onUpdateCostingStatus(id),
				updateProductStatus: updateProductStatus,
				source: 'COLLECTION_DETAILS',
				onBasicInfoUpdateSuccess: (id, product) => onBasicInfoUpdateSuccess(id, product),
				isDefaultOpenBasicInfo: openBasicInfo,
				techPackDefaultIsDesignEdit: defaultIsDesignEdit,
				costingBrandInfo: {
					brandId: collection?.brandId,
					brandName: collection?.brand,
					isBuyerRequest: false
				}
			})
		);
	};

	const setDesignIdToViewFromProduct = (
		product,
		isFromOptions,
		openBasicInfo = false,
		defaultIsDesignEdit
	) => {
		if (!isFromOptions) {
			(product?.isBasicInfoUpdated || product.isSet) && setDesignIdToView(product);
		} else {
			setDesignIdToView(product, openBasicInfo, defaultIsDesignEdit);
		}
	};

	const onSetAllSelectFalse = () => {
		setAllCheckBox(false);
	};

	const handleBeforeUnload = () => {
		const scrollPosition = window.pageYOffset;
		localStorage.setItem('scrollPosition', scrollPosition);
		dispatch(
			storeCollectionProducts({
				productList,
				page,
				hasNext,
				totalElements,
				textSearchParameter,
				sort
			})
		);
	};

	const onSetLike = (id) => {
		let tmpProductList = productList?.map((item) => {
			if (item.id === id) {
				item.liked = true;
			}
			return item;
		});
		setProductList(tmpProductList);
	};

	const onSuccessLikeProduct = () => {
		toastSuccess('Added to favourite');
	};

	const onLikeProduct = async (id) => {
		onSetLike(id, defaultFolder);
		!isShowFavouriteFolderPopup && setIsShowFavouriteFolderPopup(true);
		await dispatch(likeProduct(id, onSuccessLikeProduct));
		setCurrentLikedStyle(id);
	};

	const updateCollectionDescription = async (e) => {
		if (isEditReadOnly === false) {
			try {
				dispatch(openLoader());
				await updateCollectionById({
					id: id,
					description: e.target.value
				});
				await getCollectionDetails(id);
				setIsEditReadOnly(false);
				dispatch(closeLoader());
			} catch {
				dispatch(closeLoader());
			}
		}
	};

	const renderCollectionDescription = () => {
		if (isRequestFromSuggestedBuyer()) {
			return (
				<div className="form-group collection-description">
					{isEditReadOnly && <p className="regular-14 gray_dark_01">{collection?.description}</p>}
					{!isEditReadOnly && (
						<textarea
							readOnly={isEditReadOnly}
							onBlur={updateCollectionDescription}
							autoFocus={true}
						>
							{collection?.description}
						</textarea>
					)}
					<img
						src={`${process.env.PUBLIC_URL}/icons/edit-tool.svg`}
						alt="edit"
						className="edit-desc"
						onClick={() => {
							setIsEditReadOnly((prev) => !prev);
						}}
					/>
				</div>
			);
		}
	};

	// const renderEmptyState = () => (
	// 	<div className="d-flex justify-content-center">
	// 		{checkUserType('FASHION_DESIGNER') ? (
	// 			<button
	// 				className="button d-flex align-items-center size32 mt-3"
	// 				data-toggle="modal"
	// 				data-target="#add-multiple-design"
	// 			>
	// 				<img src={`${process.env.PUBLIC_URL}/icons/add_white.svg`} alt="add" />
	// 				<span className="ml-1">Style</span>
	// 			</button>
	// 		) : (
	// 			<>
	// 				<button
	// 					className="button outline size32 mt-3 d-flex align-items-center"
	// 					onClick={() => onAddStyleClick('SINGLE')}
	// 				>
	// 					<img src={`${process.env.PUBLIC_URL}/icons/upload-dark.svg`} alt="upload" />
	// 					<span className="ml-1">Single Style</span>
	// 				</button>
	// 				<button
	// 					className="button size32 mt-3 ml-3 d-flex align-items-center"
	// 					onClick={() => onAddStyleClick('MULTIPLE')}
	// 				>
	// 					<img src={`${process.env.PUBLIC_URL}/icons/upload-white-20.svg`} alt="upload" />
	// 					<span className="ml-1">Multiple Style</span>
	// 				</button>
	// 			</>
	// 		)}
	// 	</div>
	// );

	const onChangeCostGettingItem = (costItemsList) => {
		setCostItemsList(costItemsList);
	};

	const isHideSetOrder = () => {
		return (
			productList.filter((item) => (item.isPack || item.isSet) && selectedProductIds.includes(item.id))
				?.length > 0
		);
	};

	const updateProductCard = (data, type, requestFrom) => {
		let tmpProductList = [...productList];
		if (type === 'PACK') {
			data.forEach((item) => {
				tmpProductList.map((product) => {
					if (product.id === item.id) {
						product.isPack = item.isPack;
					}
				});
			});
		}
		if (type === 'SET') {
			if (requestFrom.type === 'CREATE_SET_OR_PACK') {
				tmpProductList = tmpProductList?.filter(
					(item) => !data?.setMemberProductIds?.includes(item.id)
				);
				tmpProductList.unshift(data);
				setTotalElements((prev) => prev + 1);
			}
			if (requestFrom.type === 'UPDATE_SET_OR_PACK') {
				tmpProductList = tmpProductList?.map((item) => {
					if (item.id === data.id) {
						item.name = data.name;
						item.referenceNumber = data.referenceNumber;
					}
					return item;
				});
			}

			if (requestFrom.type === 'DELETE') {
				getCollectionProducts(page, false, '', 'getCollectionProducts');
				setTotalElements((prev) => prev - 1);
			}
		}
		setProductList(tmpProductList);
	};

	const openEditSetOrder = (type, product) => {
		setSelectedStyle(product);
		setSetOrderType(type);
		setRequestTypeForSetOrder('UPDATE');
		setIsOpenSetOrder(true);
	};

	const openDeleteSetOrder = (type, product) => {
		setSelectedStyle(product);
		setSetOrderType(type);
		setIsOpenDeleteConfirmation(true);
	};

	const fetchDraftProductList = async () => {
		try {
			let key = 'getCollectionProducts';
			if (requestFromParam === 'photography') {
				key = 'fetchCollectionForPhotography';
			} else if (requestFromParam === 'costing') {
				key = 'fetchCollectionForCosting';
			}
			const requestBody = {
				isDrafted: true,
				collectionId: id
			};
			dispatch(openLoader());
			const { data } = await ApiClient.POST(key, requestBody, `${id}?page=${0}&size=${1000}`);
			setDraftTotalElements(data.totalElements);
			setDraftProducts(data.data);
			dispatch(closeLoader());
		} catch {
			dispatch(closeLoader());
		}
	};

	const setProductAsDraft = async (product) => {
		//const filteredList = productList.filter((product) => selectedProductIds.includes(product.id));
		const requestBody = {
			productIdList: selectedProductIds && selectedProductIds.length ? selectedProductIds : [product.id]
		};
		try {
			dispatch(openLoader());
			const response = await doCollectionWiseDraftByProductId(id, requestBody);
			await fetchDraftProductList();
			await fetchStageCounts();
			if (response?.success) {
				if (selectedProductIds && selectedProductIds.length) {
					setProductList((prev) => prev.filter((item) => !selectedProductIds.includes(item.id)));
				} else {
					setProductList((prev) => prev.filter((item) => item.id !== product.id));
				}
				setTotalElements((prev) => prev - selectedProductIds.length);
				//setIsShowDraftBoard(true);
				setOpenDraftTooltop(true);
			}
			dispatch(closeLoader());
			dispatch(storeProductData('selectedProductIds', []));
		} catch {
			dispatch(closeLoader());
		}
	};

	const unDraftProduct = async (product) => {
		try {
			dispatch(openLoader());
			await doCollectionWiseUnDraftByProductId(id, product.id);
			await fetchStageCounts();
			setDraftProducts((prev) => prev.filter((item) => item.id !== product.id));
			setDraftTotalElements((prev) => prev - 1);
			setProductList((prev) => [...prev, product]);
			setTotalElements((prev) => prev + 1);
			setIsShowDraftBoard(true);
			dispatch(closeLoader());
		} catch {
			dispatch(closeLoader());
		}
	};

	const removeDraftProduct = async (product) => {
		try {
			await onRemoveProductFromCollection(id, product.id);
			setDraftProducts((prev) => prev.filter((item) => item.id !== product.id));
			setDraftTotalElements((prev) => prev - selectedProductIds?.length || 1);
		} catch {
			dispatch(closeLoader());
		}
	};

	const onMarkProduct = async (id, saveType, parentCatergory) => {
		setShowBlockInfoModal(true);
		setMarkProductId(id);
		setBlockSaveType(saveType);
		if (parentCatergory === 'BOTTOM') {
			setIsBottomCategory(true);
		} else {
			setIsBottomCategory(false);
		}
	};

	const onCloseConfirmationModal = () => {
		setOpenConfirmation(false);
	};

	const onUnmarkProduct = async () => {
		dispatch(openLoader());
		try {
			const data = await unmarkProductBlock(unmarkPorductid);
			dispatch(closeLoader());
			updateProductCardOnMark(data);
			setOpenConfirmation(false);
			toastSuccess('Successfully updated');
		} catch (error) {
			printApiError(error);
		}
	};

	useEffect(() => {
		fetchFittingResponse();
	}, [markProductId]);

	const fetchFittingResponse = async () => {
		if (markProductId) {
			try {
				dispatch(openLoader());
				const data = await getFittingResponse(markProductId);
				setFittingResponse(data);
				dispatch(closeLoader());
			} catch {
				dispatch(closeLoader());
			}
		}
	};

	const updateProductCardOnMark = (data) => {
		let tmpProductList = [...productList];

		let updatedProduct = data;
		tmpProductList = tmpProductList.map((product) => {
			if (product.id === updatedProduct.id) {
				return {
					...product,
					isBlock: updatedProduct.isBlock
				};
			}
			return product;
		});

		setProductList(tmpProductList);
	};

	const handleOnFittingUpdate = async () => {
		try {
			dispatch(openLoader());
			setShowBlockInfoModal(false);
			toastSuccess('Updated successfully');
			await fetchFittingResponse();
			dispatch(closeLoader());
		} catch {
			dispatch(closeLoader());
		}
	};

	const onCloseUpdateFittingInfoModal = () => {
		setShowBlockInfoModal(false);
		setFittingResponse(null);
	};

	useEffect(() => {
		setTimeout(() => {
			setOpenDraftTooltop(false);
		}, 5000);
	}, [isOpenDraftTooltop]);

	const getPriceRangeAndCategoryCounts = () => {
		let groupedProducts = groupByKey(productList, 'groupByKeyName', sort);
		let priceRangeCounts = {};
		Object.keys(groupedProducts)?.forEach((key) => {
			priceRangeCounts[key] = groupedProducts[key]?.length;
		});

		return Object.keys(priceRangeCounts)?.map((item, index) => (
			<p key={`price_range_${index}`} className="regular-14 gray_dark_01 mr-4 text-nowrap">
				{getGroupKeyName(item)} ({priceRangeCounts[item]})
			</p>
		));
	};

	const renderCollectionSummary = () => {
		return (
			<div className="total-summary mb-2">
				<div className="d-flex flex-wrap py-2">
					{sort === 'stage,asc' &&
						Object.keys(stageCounts)?.map((item, index) => (
							<p key={`stage_${index}`} className="regular-14 gray_dark_01 mr-4 text-nowrap">
								{capitalizeFirstLetter(item)} ({stageCounts[item]})
							</p>
						))}
					{sort === 'tag,asc' &&
						Object.keys(tagCounts)?.map((item, index) => (
							<p key={`tag_${index}`} className="regular-14 gray_dark_01 mr-4 text-nowrap">
								{item === 'NoTag' ? 'No Tag' : capitalizeFirstLetter(item)} ({tagCounts[item]}
								)
							</p>
						))}
					{(sort === 'priceRange' || sort === 'category') && getPriceRangeAndCategoryCounts()}
				</div>
			</div>
		);
	};

	const updateTagList = (payload) => {
		let tmpProductList = [...productList];
		payload.forEach((item) => {
			tmpProductList = tmpProductList?.map((product) => {
				if (product.id === item.id) {
					product.tagResponseList = item.tagResponseList;
				}
				return product;
			});
		});
		setProductList(tmpProductList);
	};

	const getGroupKeyName = (key) => {
		if (sort === 'category') {
			return key === 'no_key' ? 'No Category' : replaceUnderLine(key);
		} else if (sort === 'priceRange') {
			return key === 'no_key' ? 'No Price Range' : replaceUnderLine(key);
		} else {
			return key === 'no_key' ? 'No Tag' : replaceUnderLine(key);
		}
	};

	const renderGroupWiseCollectionDesigns = () => {
		if (SORTING_TYPE.includes(sort)) {
			let groupedProducts = groupByKey(productList, 'groupByKeyName', sort);
			return Object.keys(groupedProducts)?.map((key) => {
				let products = groupedProducts[key];
				return (
					<React.Fragment key={`group_products_${key}`}>
						<h3 className="semibold-16 mb-3">
							{getGroupKeyName(key)} ({groupedProducts[key]?.length})
						</h3>
						{renderCollectionDesigns(products, key)}
					</React.Fragment>
				);
			});
		} else {
			return renderCollectionDesigns(productList);
		}
	};

	const getOfferPriceForProduct = async () => {
		dispatch(openLoader());
		try {
			const response = await getPickAndChoosePrice(idsForOfferPrice);

			setAllOfferPrices((prevPrices) => ({
				...prevPrices,
				...response
			}));
			dispatch(closeLoader());
		} catch {
			dispatch(closeLoader());
		}
	};

	useEffect(() => {
		if (productList?.length > 0) {
			const startIdx = Math.max(0, productList.length - 20);
			const latestIds = productList.slice(startIdx).map((design) => design.id);
			setIdsForOfferPrice(latestIds);
		}
	}, [productList]);

	useEffect(() => {
		if (idsForOfferPrice?.length > 0) {
			getOfferPriceForProduct();
		}
	}, [idsForOfferPrice]);

	const renderCollectionDesigns = (products, keyName = '') => {
		return (
			<div
				className={`design-list-row ${
					defaultViewType === LIST_VIEW_TYPE.NARROW_VIEW
						? 'narrow-view'
						: defaultViewType === LIST_VIEW_TYPE.IMAGE_VIEW
							? 'image-view'
							: ''
				}
                  `}
			>
				{products?.length > 0 &&
					products?.map((product, idx) => {
						const offerPriceInfo = allOfferPrices[product.id];
						const isSelected = selectedProductIds?.includes(product.id);

						return (
							<DesignCard
								key={`product_${product.id}_${keyName || ''}`}
								productInfo={{ ...product, isSelected }}
								collectionId={id}
								onUpdateBasicInfo={(data) => onUpdateBasicInfo(data)}
								onRemoveProductFromCollection={onRemoveProductFromCollection}
								setDesignIdToView={setDesignIdToViewFromProduct}
								onLikeProduct={onLikeProduct}
								onUpdateDesignImage={(id, docUrl) => onUpdateDesignImage(id, docUrl)}
								onSetAllSelectFalse={onSetAllSelectFalse}
								onCreateOption={(id) => onCreateOption(id, idx + 1)}
								requestFromParam={requestFromParam}
								isShowPrice={isShowPriceType}
								handleBeforeUnload={handleBeforeUnload}
								openEditSetOrder={openEditSetOrder}
								openDeleteSetOrder={openDeleteSetOrder}
								draftProduct={setProductAsDraft}
								defaultViewType={defaultViewType}
								productWiseTags={productWiseTags}
								fetchAllTags={fetchAllTags}
								updateTagList={updateTagList}
								showFabricStatus={productsWithoutFabric.includes(product)}
								onMarkProduct={onMarkProduct}
								setOpenConfirmation={setOpenConfirmation}
								setUnmarkProductId={setUnmarkProductId}
								offerPriceInfo={offerPriceInfo}
								artworkSoldStatus={artboardProducts[product?.id]}
								setProducts={setProductList}
								getCollectionProducts={getCollectionProducts}
								failedTaskUpdateIds={failedTaskUpdateIds}
							/>
						);
					})}
			</div>
		);
	};
	const handleRedirect = () => {
		let path;
		switch (requestFromParam) {
			case 'costing':
				path = '/costing/initial';
				break;
			case 'blockLibrary':
				path = '/assets?activeTab=BLOCK_LIBRARY';
				break;
			default:
				path = '/collections/list';
				break;
		}
		return path;
	};

	const goToInitialCollection = async () => {
		navigate(`/collections/view/${collection?.id}`);
		await getCollectionProducts(0, false, '', 'getCollectionProducts');
		dispatch(clearGlobalFilter());
	};

	return (
		<>
			<div className="top-header collection-topbar">
				<div className={`${isShowFavouriteFolderPopup ? 'show' : 'hide'}`}>
					<SelectFolderPopup
						onClose={() => setIsShowFavouriteFolderPopup(false)}
						isShowCreateNew={isShowCreateNew}
						setIsShowCreateNew={setIsShowCreateNew}
						currentLikedStyle={currentLikedStyle}
					/>
				</div>
				{/* Header , upper section of the tabs, Teams and add member section */}
				<div className="container-fluid  pt-3 pl-0">
					<div className="row">
						<div className="col-md-8">
							<div className="collection-overview d-flex align-items-center">
								<BackButton url={handleRedirect()} />
								<h1 className="semibold-14 m-0 ml-2">
									{collection?.name ? collection.name : 'N/A'}{' '}
									{collection?.projectName && (
										<>
											<span className="gray_dark_01 mr-1">/</span>
											<span
												className="blue cursor-pointer text-underline"
												onClick={() => {
													mixPanelTrakingEvent({
														type: MIX_PANEL_EVENTS.ENTITY_LINK_ON_CLICK,
														body: {
															collectionId: id,
															entityType: 'COLLECTION',
															collectionName: collection.name,
															projectName: collection?.projectName
														}
													});
													window.open(
														`/my-project/${collection?.projectId}`,
														'_blank'
													);
												}}
											>
												{` ${collection?.projectName}`}
											</span>
										</>
									)}
								</h1>
								<div className="collection-status pl-3 mr-2">
									{collection?.brand && (
										<span className="brand-common-design">{collection?.brand}</span>
									)}
								</div>
								{collection?.collectionViewType === 'AUTO_GENERATE' && (
									<CollectionTags tags={collection?.tagResponseList} />
								)}
								{collection?.isBuyerSelection && (
									<div>
										<span className="status pink-1 buyers-selection">
											Buyer's Selection
										</span>
									</div>
								)}
								{!isRequestFromSample() && !isRequestFromCosting() && (
									<div className="ml-3">
										<span
											className="regular-14 primary_bright_01 cursor-pointer"
											onClick={onEditCollection}
										>
											Edit
										</span>
									</div>
								)}
								{isRequestFromCosting() && collection?.id && (
									<>
										<span className="common-devider mx-3"></span>
										<button
											className="button text-only"
											onClick={() => goToInitialCollection()}
										>
											<span className="blue">View Requested Collection</span>
										</button>
									</>
								)}
							</div>
						</div>
						<div className="col-md-4">
							{!isRequestFromSample() && !isRequestFromCosting() && (
								<div className="d-flex justify-content-end align-items-center">
									<div className="add-buyer d-flex flex-column flex-sm-row align-items-center justify-content-end">
										{collection?.collectionViewType === 'REQUESTED' &&
											collection?.requestedType === 'COLLECTION' &&
											requestFromParam !== 'photography' && (
												<div className="approve-button ml-2">
													<button
														disabled={isDisableCompleteButton()}
														className="button approve size32"
														onClick={onComplete}
													>
														{collection?.isCompleted
															? 'Completed'
															: 'Complete the Request'}
													</button>
												</div>
											)}
										<div className="position-relative">
											<AddMemberToCollection
												collectionId={id}
												brandId={collection?.brandId}
											/>
										</div>
									</div>
								</div>
							)}
						</div>
					</div>
				</div>
				{/* *************************************************************** */}

				{showAddNewDesignModal && (
					<UploadStyles
						onNewDesignModal={onAddNewDesignModal}
						collectionDetails={collection}
						onClose={() => {
							setShowAddNewDesignModal(false);
							setUploadType('');
						}}
						uploadType={uploadType}
					/>
				)}
				{/* Tab sections */}
				<div className="navigation-tab">
					<ul className="collection-details-tab">
						<li
							className={`${activeTab === `designs` ? `active` : ``}`}
							onClick={() => {
								window.scrollTo(0, 0);
								setActiveTab('designs');
								dispatch(
									setCurrentActivePage({
										id: id,
										type: 'COLLECTION_CONVERSATION',
										pageType: 'DETAILS'
									})
								);
								dispatch(storeProductData('selectedProductIds', []));
								getCollectionDetails(id);
							}}
						>
							Designs
						</li>
						{!isRequestFromSample() && !isRequestFromCosting() && (
							<>
								<li
									className={`${activeTab === `costing` ? `active` : ``}`}
									onClick={async () => {
										window.scrollTo(0, 0);
										dispatch(
											setCurrentActivePage({
												type: 'COSTING_CONVERSATION',
												pageType: 'LIST'
											})
										);
										setActiveTab('costing');
										await onClearSelectedProducts();
									}}
								>
									Costing
								</li>
								{/* <li
                  className={`${activeTab === `moodboard` ? `active` : ``}`}
                  onClick={async () => {
                    window.scrollTo(0, 0);
                    dispatch(
                      setCurrentActivePage({
                        id: id,
                        type: 'COLLECTION_CONVERSATION',
                        pageType: 'DETAILS'
                      })
                    );
                    setActiveTab('moodboard');
                    await onClearSelectedProducts();
                  }}
                >
                  Moodboard
                </li> */}

								{/* <li
                  className={`${activeTab === `development` ? `active` : ``}`}
                  onClick={async () => {
                    window.scrollTo(0, 0);
                    setActiveTab('development');
                    await onClearSelectedProducts();
                  }}
                >
                  Development
                </li> */}

								<li
									className={`${activeTab === `sample` ? `active` : ``}`}
									onClick={async () => {
										window.scrollTo(0, 0);
										dispatch(
											setCurrentActivePage({
												type: 'SAMPLE_CONVERSATION',
												pageType: 'LIST'
											})
										);
										setActiveTab('sample');
										await onClearSelectedProducts();
									}}
								>
									Sample
								</li>
								<li
									className={`${activeTab === `RANGE_PLAN` ? `active` : ``}`}
									onClick={() => setActiveTab('RANGE_PLAN')}
								>
									Range Plan
								</li>
								<li
									className={`${activeTab === `FILES` ? `active` : ``}`}
									onClick={() => setActiveTab('FILES')}
								>
									TP & collection files
								</li>
							</>
						)}
					</ul>
				</div>

				{activeTab === `designs` && (
					<div className="filter-container-top collection-details-filter-container pt-2 pb-2 bg-white d-block">
						<div className="filter-and-actions d-flex justify-content-between align-items-center w-100">
							{renderTopBar()}

							<div className="filter-actions collection-details-filter">
								<div className="form-group size32 m-0 search-filter filter-with-animation">
									<div
										className={
											isSearchBoxHidden
												? 'with-icon right-icon hidden'
												: 'with-icon right-icon'
										}
									>
										<input
											type="text"
											autoComplete="off"
											placeholder="Design name & number"
											name="name"
											onChange={handleTextSearch}
											value={textSearchParameter}
										/>
										<span
											className="right-icon"
											onClick={() => setIsSearchBoxHidden((prev) => !prev)}
										>
											<svg
												xmlns="http://www.w3.org/2000/svg"
												width={23}
												height={22}
												viewBox="0 0 23 22"
												fill="none"
											>
												<path
													d="M10.543 16.5C14.3399 16.5 17.418 13.422 17.418 9.625C17.418 5.82804 14.3399 2.75 10.543 2.75C6.74601 2.75 3.66797 5.82804 3.66797 9.625C3.66797 13.422 6.74601 16.5 10.543 16.5Z"
													stroke="#21242B"
													strokeWidth="1.5"
													strokeLinecap="round"
													strokeLinejoin="round"
												/>
												<path
													d="M19.2526 18.3346L15.5859 14.668"
													stroke="#21242B"
													strokeWidth="1.5"
													strokeLinecap="round"
													strokeLinejoin="round"
												/>
											</svg>
										</span>
									</div>
								</div>
								<ListViewType
									type="COLLECTION_DETAILS"
									onSelectType={(selected) => {
										setDefaultViewType(selected);
									}}
									openPresentationView={() => setIsPlay(true)}
								/>

								{isRequestFromPhotography() ? (
									<div className="sort-button mt-1 mx-0">
										<select
											className="border-0"
											onChange={onPhotographySort}
											value={sort}
										>
											<option value="product.id,DESC">Newest</option>
											<option value="product.id,ASC">Oldest</option>
										</select>
									</div>
								) : (
									<div className="sort-button mt-1 mx-0">
										<select className="border-0" onChange={onSortDetails} value={sort}>
											<option value="stage,asc">Group by stage</option>
											<option value="tag,asc">Group by tag</option>

											<option value="id,desc">Newest</option>
											<option value="id,asc">Oldest</option>
											{!isRequestFromCosting() && !isRequestFromSample() && (
												<>
													<option value="lastResponseTime,desc">
														Last modified
													</option>
													<option value="TECHPACK">Techpack</option>
													<option value="DEVELOPMENT">Development</option>
													<option value="COMPLETE">Complete</option>
													<option value="SOLD">Sold</option>
													<option value="category">Category</option>
													<option value="priceRange">Price Range</option>
												</>
											)}
										</select>
									</div>
								)}
								{!isRequestFromCosting() &&
								!isRequestFromSample() &&
								(getPrimaryUserType() === 'FASHION_DESIGNER' ||
									getPrimaryUserType() === 'GRAPHICS_DESIGNER' ||
									getPrimaryUserType() === 'THREE_D_DESIGNER') ? (
									<span
										className="cursor-pointer regular-14 gray_dark_01 d-flex align-items-center mr-3"
										data-toggle="modal"
										data-target="#add-multiple-design"
										onClick={() => {
											localStorage.setItem('fromRoute', location.pathname);
										}}
									>
										<img
											src={`${process.env.PUBLIC_URL}/icons/add-round.svg`}
											alt="design"
											className="mr-1"
										/>
										Design
									</span>
								) : (
									<>
										{/* {renderMoreDesignButton()} */}
										{uploadTechpackJourneyButtonRender()}
									</>
								)}

								{collection?.brandId && (
									<ShareSuggestedCollection
										brandId={collection.brandId}
										collectionId={id}
										collectionInfo={{
											brand: collection.brand,
											season: collection.season,
											market: collection.market,
											collectionId: id,
											approvalStatus: collection?.approvalStatus
										}}
									/>
								)}
								<div className="draft-Button">
									<button
										className="button outline size32 ml-2 text-nowrap"
										onClick={() => setIsShowDraftBoard(true)}
									>
										Draft {draftTotalElements ? `(${draftTotalElements})` : ''}
									</button>
									{isOpenDraftTooltop && (
										<div className="custom-tooltip position-static">
											<p className="tooltiptext shadow-2dp">
												Click here to view send to draft styles
											</p>
										</div>
									)}
								</div>
							</div>
						</div>
						<div className="filter-chip-container my-1">
							<Chip
								maxChar={90}
								parentComponent={'COLLECTION_DETAILS'}
								entityId={id}
								entityType="COLLECTION"
								settingsKey="COLLECTION_DETAILS_FILTER"
								isFilterOpen={showFilter}
							/>
						</div>
					</div>
				)}
			</div>
			{renderPanelBar()}
			{/* Render Design Tab */}
			{activeTab === 'designs' && (
				<section className="filter-data-container filter-v3-data-container bg-white py-0">
					{showFilter && (
						<FilterComponent
							filterPageName={allFilterPages.COLLECTION_DETAILS}
							fields={collectionFilters()}
							showFilter={showFilter}
							isDependentFilter={true}
							className="collection-detail-sidebar"
						/>
					)}

					{renderCollectionDescription()}
					<div className="data-table">
						<div className="collection-details-container">
							{defaultViewType !== LIST_VIEW_TYPE.LIST_VIEW && (
								<div className="collection-details-data w-100">
									<div className="design-list-container mb-4 collection-details-design">
										<div className="container-fluid px-0">
											<section className="all-quotes-section px-0 py-0">
												{productList?.length === 0 && (
													<div
														className="alert alert-secondary text-center"
														role="alert"
													>
														<p className="mb-4">No style found</p>
														{/* {renderEmptyState()} */}
														{renderUploadTpEmptyState()}
													</div>
												)}
											</section>
											{SORTING_TYPE.includes(sort) && renderCollectionSummary()}
											{renderGroupWiseCollectionDesigns()}
										</div>
									</div>
									{requestFromParam !== 'photography' && (
										<div className="col-md-1 one-sixth text-right">
											<div className="conversation-btn">
												<button
													className="button text absolute-conversation-btn"
													onClick={() => {
														setShowComment(true);
														setCollection((prev) => ({
															...prev,
															noOfUnreadMessage: 0
														}));
													}}
												>
													{(collection?.noOfUnreadMessage > 0 || newPost?.id) && (
														<img
															src={`${process.env.PUBLIC_URL}/icons/comment-not-read.svg`}
															alt="not read"
														/>
													)}
													{!collection?.noOfUnreadMessage && !newPost?.id && (
														<img
															src={`${process.env.PUBLIC_URL}/icons/comments-gray.svg`}
															alt="not read"
														/>
													)}
												</button>
											</div>
											<SampleComment
												sampleRequestId={id}
												showComment={showComment}
												setShowComment={() => handleCommentClose()}
												brandInfo={{
													brandId: collection?.brandId,
													brandName: collection?.brand
												}}
												postTypeFilter={
													requestFromParam === 'photography'
														? 'PHOTOGRAPHY_REQUEST_COMMENT'
														: POST_TYPE_FILTER
												}
												getPostUrl={
													requestFromParam === 'photography'
														? 'getPhotographyConversation'
														: 'getCollectionConversation'
												}
												addPostUrl={'addNewConversationPost'}
												postTypeId={
													requestFromParam === 'photography'
														? 'photographyRequestId'
														: 'collectionId'
												}
												topic={
													requestFromParam === 'photography'
														? 'PHOTOGRAPHY_CONVERSATION'
														: 'COLLECTION_CONVERSATION'
												}
												styleList={productList?.filter(
													(product) => product.referenceNumber
												)}
											/>
										</div>
									)}
								</div>
							)}
							{defaultViewType === LIST_VIEW_TYPE.LIST_VIEW && (
								<CollectionDetailsTableView
									handleBeforeUnload={handleBeforeUnload}
									productWiseTags={productWiseTags}
									updateTagList={updateTagList}
									fetchAllTags={fetchAllTags}
									productList={productList}
									sort={sort}
									stageCounts={stageCounts}
									tagCounts={tagCounts}
									setDesignIdToView={setDesignIdToView}
									getGroupKeyName={getGroupKeyName}
									SORTING_TYPE={SORTING_TYPE}
								/>
							)}
							{isShowDraftBoard && (
								<StyleDraftBoard
									removeDraftProduct={removeDraftProduct}
									unDraftProduct={unDraftProduct}
									totalDraft={draftTotalElements}
									products={draftProducts}
									onClose={() => {
										setIsShowDraftBoard(false);
									}}
								/>
							)}
						</div>
					</div>
				</section>
			)}
			{activeTab === 'RANGE_PLAN' && (
				<div className="body-content pt-0 bg-white with-tab">
					<RangePlanTable
						entityType={RANGE_PLAN_ENTITY_TYPE.COLLECTION}
						setActiveTab={setActiveTab}
						brandName={collection?.brand}
						brandId={collection?.brandId}
					/>
				</div>
			)}

			{activeTab === 'costing' && <CostingList collectionId={id} />}

			{activeTab === 'moodboard' && collection?.moodBoardId && (
				<>
					<MoodBoard moodboardId={collection.moodBoardId} isShowTop={false} />
					<div className="col-md-1 one-sixth text-right">
						<div className="conversation-btn">
							<button
								className="button text absolute-conversation-btn"
								onClick={() => {
									setShowComment(true);
									setCollection((prev) => ({ ...prev, noOfUnreadMessage: 0 }));
								}}
							>
								{(collection?.noOfUnreadMessage > 0 || newPost?.id) && (
									<img
										src={`${process.env.PUBLIC_URL}/icons/comment-not-read.svg`}
										alt="not read"
									/>
								)}
								{!collection?.noOfUnreadMessage && !newPost?.id && (
									<img
										src={`${process.env.PUBLIC_URL}/icons/comments-gray.svg`}
										alt="not read"
									/>
								)}
							</button>
						</div>
						<SampleComment
							sampleRequestId={collection.id}
							showComment={showComment}
							setShowComment={() => handleCommentClose()}
							brandInfo={{ brandId: collection.brandId, brandName: collection.brand }}
							postTypeFilter={
								requestFromParam === 'photography'
									? 'PHOTOGRAPHY_REQUEST_COMMENT'
									: POST_TYPE_FILTER
							}
							getPostUrl={
								requestFromParam === 'photography'
									? 'getPhotographyConversation'
									: 'getCollectionConversation'
							}
							addPostUrl={'addNewConversationPost'}
							postTypeId={
								requestFromParam === 'photography' ? 'photographyRequestId' : 'collectionId'
							}
							topic={
								requestFromParam === 'photography'
									? 'PHOTOGRAPHY_CONVERSATION'
									: 'COLLECTION_CONVERSATION'
							}
						/>
					</div>
				</>
			)}

			{activeTab === 'development' && <SampleDevelopment isHideSetOrder={isHideSetOrder} />}

			{activeTab === 'sample' && <RequestedSampleFromCollection id={id} />}

			{activeTab === 'FILES' && (
				<div>
					<div className="inner-tabs products-tab pt-4 px-4 bg-white">
						<ul>
							<li
								className={`${selectedJourneyTab === 'upload' ? 'active' : ''}`}
								onClick={() => setSelectedJourneyTab('upload')}
							>
								Upload TP ({mergedFilesCount})
							</li>
							<li
								className={`${selectedJourneyTab === 'collection' ? 'active' : ''}`}
								onClick={() => setSelectedJourneyTab('collection')}
							>
								Collection files
							</li>
						</ul>
					</div>
					<div
						className={`${selectedJourneyTab === 'upload' ? 'multiple-techpack-upload-section pt-3 bg-white' : 'collection-file-section bg-white mx-auto p-5 mt-4'}`}
					>
						{selectedJourneyTab === 'upload' && (
							<MultipleTechpackJourney
								collectionId={id}
								setSelectedJourneyTab={setSelectedJourneyTab}
								MergedFilesCount={setMergedFilesCount}
							/>
						)}

						{selectedJourneyTab === 'collection' && (
							<FileUploads
								id={id}
								originFrom="FILE"
								onSetActiveTool={() => false}
								onPlaceImageOnArtboard={() => false}
								entityType="COLLECTION"
								allowedFileType="*"
							/>
						)}
					</div>
				</div>
			)}
			<div className="add-more-designs">
				<div
					className={`add-more get-cost-side-pop ml-auto custom-scrollbar ${
						costItemsList.length ? `open` : ``
					}`}
				>
					<div className="header d-flex justify-content-between align-items-start">
						<h4>Share quantity and target price</h4>
						<div>
							<div
								className="cursor-pointer d-inline-block"
								onClick={() => setCostItemsList([])}
							>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="18"
									height="18"
									viewBox="0 0 22.43 22.429"
								>
									<path
										id="close"
										d="M13.27,11.351,22,2.617A1.453,1.453,0,0,0,19.949.562L11.215,9.3,2.481.562A1.453,1.453,0,0,0,.426,2.617L9.16,11.351.426,20.085a1.453,1.453,0,1,0,2.055,2.055l8.734-8.734,8.734,8.734A1.453,1.453,0,1,0,22,20.085Zm0,0"
										transform="translate(0 -0.136)"
									/>
								</svg>
							</div>
						</div>
					</div>

					<div className="added-item">
						{costItemsList.map((product, i) => {
							return (
								<CostGettingItem
									key={i}
									index={i}
									product={product}
									products={costItemsList}
									onChange={onChangeCostGettingItem}
								/>
							);
						})}
					</div>
					<div className="p-4 w-100 text-right position-relative bg-white">
						<button className="m-0 btn-brand shadow" onClick={() => addProductToPricing()}>
							Get costing
						</button>
					</div>
				</div>
			</div>

			<StyleDetailsBottomActions
				productList={productList}
				setProductList={setProductList}
				collectionInfo={collection}
				isHideSetOrder={isHideSetOrder}
				additional={{
					id,
					onAddNewDesignModal,
					selectedStyle,
					setSelectedStyle,
					updateProductCard,
					handleSelectAll
				}}
				requestType="COLLECTION_DETAILS"
				setProductAsDraft={setProductAsDraft}
				productWiseTags={productWiseTags}
				updateTagList={updateTagList}
				fetchAllTags={fetchAllTags}
				requestFromParam={requestFromParam}
				setPage={setPage}
				page={page}
				collectionRef={collectionRef?.current}
				totalElements={totalElements}
				getCollectionProducts={getCollectionProducts}
				setIsPlay={setIsPlay}
				isSelectOnNextPage={isSelectOnNextPage}
				setIsSelectOnNextPage={setIsSelectOnNextPage}
				setIsShowPublishDesign={setIsShowPublishDesign}
				artboardProducts={artboardProducts}
				setFailedTaskUpdateIds={setFailedTaskUpdateIds}
			/>

			<CollectionPresentation
				isPlay={isPlay}
				collectionName={collection?.name}
				collectionId={id}
				onCLoseModal={() => setIsPlay(false)}
				entityType="COLLECTION"
				selectedProductIds={selectedProductIds}
			/>
			{isOpenSetOrder && (
				<CreateSetOrder
					onSubmitSuccess={onClearSelectedProducts}
					updateProductCard={updateProductCard}
					requestType={requestTypeForSetOrder}
					productIds={selectedProductIds}
					selectedProduct={selectedStyle}
					setOrderType={setOrderType}
					onClose={() => {
						setSelectedStyle(null);
						setSetOrderType('');
						setRequestTypeForSetOrder('');
						setIsOpenSetOrder(false);
					}}
					entityId={id}
					entityType="COLLECTION"
				/>
			)}
			{isOpenDeleteConfirmation && (
				<DeleteSetOrder
					selectedProduct={selectedStyle}
					setOrderType={setOrderType}
					onClose={() => {
						setSelectedStyle(null);
						setSetOrderType('');
						setIsOpenDeleteConfirmation(false);
					}}
					updateProductCard={updateProductCard}
				/>
			)}
			{showBlockInfoModal && (
				<UpdateFittingModal
					productId={markProductId}
					isShowClose={true}
					blockResponse={fittingResponse}
					onAddSuccess={handleOnFittingUpdate}
					onCloseModal={() => onCloseUpdateFittingInfoModal()}
					blockSaveType={blockSaveType}
					updateProductCardOnMark={updateProductCardOnMark}
					openedFrom={'collection'}
					isBottomCategory={isBottomCategory}
				/>
			)}
			{openConfirmation && (
				<ConfirmationModal
					title={'Unmark block'}
					closeModal={onCloseConfirmationModal}
					description={' about unmarking this block?'}
					callback={onUnmarkProduct}
					footerType={'CLOSE'}
				/>
			)}
			{isShowPublishDesign && (
				<PublishDesign
					selectedProducts={selectedProductIds}
					onClose={() => {
						dispatch(storeProductData('selectedProductIds', []));
						setIsShowPublishDesign(false);
					}}
					onSubmitSuccess={handleUpdateDesignOnPublish}
				/>
			)}
		</>
	);
};

export default CollectionDetails;
